import basepath from './basepath.js';

let _url; 

/**
 * Returns the base url of the given url
 * @module baseurl
 * @category url
 * @param {string} url - The url
 */
export default function baseurl(){
	if(_url) return _url;
	let loc = basepath(document.location.href);
	let dom = document.querySelector('base');
	_url = dom ? dom.getAttribute('href') : loc;
	_url = _url ? _url : loc;
	return _url;
}
export { baseurl };